import news1 from '../images/news/Mounstruo.png';
import newsMobile1 from '../images/news/Mounstruo_mobile.png';
import news2 from '../images/news/ZBrush.png';
import newsMobile2 from '../images/news/ZBrush_mobile.png';
import news3 from '../images/news/impresion.png';
import newsMobile3 from '../images/news/impresion_mobile.png';

const news = [
	// {
	// 	title: 'Seminario presencial Blender + Impresión 3D + IA',
	// 	description: '',
	// 	page: 'https://www.libel.academy/chia/',
	// 	image: news3,
	// 	imageMobile: newsMobile3,
	// },
	{
		title: 'Máster Mounstro academy',
		description: '',
		page: 'https://www.libel.academy/creacion-de-criaturas/',
		image: news1,
		imageMobile: newsMobile1,
	},
	{
		title: '6X1 En ZBrush (6 entrenamientos por el precio 1) ',
		description: '',
		page: 'https://www.libel.academy/especialista-3d/',
		image: news2,
		imageMobile: newsMobile2,
	},
];

export default news;
